import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { PrivacyPolicyContent } from '../components/privacy-policy-content';

const PrivacyPolicyPage = () => (
    <Layout>
        <SEO title="Private Policy" />
        <div class="container" style={{ textAlign: 'justify' }}>
            <PrivacyPolicyContent />
        </div>
    </Layout >
)

export default PrivacyPolicyPage
